<!-- 转账管理 -->
<template>
  <div>
    <app-breadcrumb />
    <div class="page-container transfer-manage">
      <el-form size="small" :inline="true" :model="listQuery" label-width="auto" label-position="right">
        <!-- 付款人编号-->
        <el-form-item :label="$t('poOrder.payerNo') + ':'">
          <el-input v-model.trim="listQuery.outUserCode" clearable />
        </el-form-item>
        <!-- 收款方用户编号-->
        <el-form-item :label="$t('FiAcTrans.inUserCode') + ':'">
          <el-input v-model.trim="listQuery.inUserCode" clearable />
        </el-form-item>
        <!-- 账户类型-->
        <el-form-item :label="$t('fi.lable.account.type') + ':'">
          <el-select v-model="listQuery.acType" placeholder="" clearable>
            <el-option value="" />
            <el-option v-for="i in actypeList" :key="i.code" :label="$lt(initDict.actype, i.code)" :value="i.code" />
          </el-select>
        </el-form-item>
        <!-- 选择日期范围 -->
        <el-form-item :label="$t('Common.SelectDateRange') + ':'" >
          <el-date-picker
              v-model="listQuery.fromCreateDate"
              type="date"
              style="width: 130px;"
              value-format="yyyy-MM-dd"
              placeholder=""
          />&nbsp;&nbsp; - &nbsp;&nbsp;
          <el-date-picker
              v-model="listQuery.toCreateDate"
              type="date"
              style="width: 130px;"
              value-format="yyyy-MM-dd"
              placeholder=""
          />
        </el-form-item>
        <el-row>
          <el-button :loading="btnLoading" size="small" type="primary" icon="el-icon-search" @click="handleFilter">{{ $t('function.menu.search') }}</el-button>
          <el-button :loading="btnLoading" size="small" type="success" icon="el-icon-plus" @click="addBtn">{{ $t('status.new') }}</el-button>
<!--          <el-button :loading="btnLoading" size="small" type="success" icon="el-icon-plus" @click="bonusBtn">{{ $t('奖金转电子币') }}</el-button>-->
        </el-row>
      </el-form>
      <el-table
          v-loading="tableLoading"
          :data="list"
          border
          fit
          size="mini"
          stripe
          style="width: 100%"
      >
        <!-- 付款人编号 -->
        <el-table-column :label="$t('poOrder.payerNo')" prop="outUserCode" align="center"/>
        <!-- 付款人姓名 -->
        <el-table-column :label="$t('poOrder.payerName')" prop="outUserName" align="center"/>
        <!-- 账户类型 -->
        <el-table-column :label="$t('fi.lable.account.type')" align="center">
         <template v-slot="{row}">
           {{ $lt(initDict.acType, $lt(initDict.actype, row.acType)) }}
         </template>
        </el-table-column>
        <!-- 付款金额 -->
        <el-table-column :label="$t('fi.pay.money')" prop="outMoney" align="center"/>
        <!-- 收款方用户编号 -->
        <el-table-column :label="$t('FiAcTrans.inUserCode')" prop="inUserCode" align="center"/>
        <!-- 付款人姓名 -->
        <el-table-column :label="$t('FiAcTrans.inUserName')" prop="inUserName" align="center"/>
        <!-- 类型 -->
        <el-table-column :label="$t('sysDataLog.changeType')" align="center">
         <template v-slot="{row}">
           {{ $lt(initDict.transType, row.transType) }}
         </template>
        </el-table-column>
        <!-- 创建时间 -->
        <el-table-column :label="$t('Common.createTime')" prop="createTime" align="center"/>
        <!-- 状态 -->
        <el-table-column :label="$t('fiBankbookTemp.status')" prop="status" align="center">
         <template v-slot="{row}">
           {{ $lt(initDict.status, row.status) }}
         </template>
        </el-table-column>
        <!-- 备注 -->
        <el-table-column :label="$t('poReturn.createRemark')" prop="memo" align="center"/>
      </el-table>
      <pagination
          v-show="total>0"
          :total="total"
          :page.sync="listQuery.page"
          :limit.sync="listQuery.limit"
          @pagination="getList"
      />
    </div>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination"
import { getFiAcTrans } from '@/api/ay-account-manager'
export default {
  name: 'TransferManage',
  components: { Pagination },
  data() {
    return {
      btnLoading: false,
      tableLoading: false,
      list: [],
      total: 0,
      listQuery: {
        page: 1,
        limit: 10
      },
      initDict: {
        actype: 'fiacinput.actype.cn',
        transType: 'fi_ac_trans.status',
        status: 'fi_ac_trans.type'
      }
    }
  },
  computed: {
    actypeList() {
      return this.$ll(this.initDict.actype).filter(ele => ele.code === 'F$' || ele.code === 'H0')
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      this.tableLoading = true
      this.btnLoading = true
      getFiAcTrans({ ...this.listQuery }).then(res => {
        this.list = res.data.records
        this.total = +res.data.total || 0
        this.tableLoading = false
        this.btnLoading = false
      }).catch(err => {
        console.warn(err)
        this.tableLoading = false
        this.btnLoading = false
      })
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    addBtn() {
      this.$router.push({name: 'AddTransfer'})
    },
    bonusBtn() {
      this.$router.push({name: 'BonusElectronicCurrency'})
    }
  }
}
</script>

<style scoped>

</style>
